export default __webpack_public_path__ + "static/media/phonepresik.1fa065f2.png";